import { ChevronDown, ChevronUp } from 'lucide-react';

interface CaretProps {
  up?: boolean;
}

export default function Caret({ up = false }: CaretProps) {
  return up ? (
    <ChevronUp size={24} aria-hidden="true" />
  ) : (
    <ChevronDown size={24} aria-hidden="true" />
  );
}
